import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth.jsx';
import { logout } from '../services/auth.js';

export default function Navbar() {
  const { usuario, recarregar } = useAuth();
  const navigate = useNavigate();

  async function handleSair() {
    await logout();
    await recarregar();
    navigate('/');
  }

  return (
    <nav className="navbar navbar-expand-lg navbar-encurtador" aria-label="Navegação principal">
      <div className="container">
        <Link className="navbar-brand text-light" to="/">
          mathee.us
        </Link>
        <ul className="navbar-nav ms-auto flex-row gap-3">
          <li className="nav-item">
            <Link className="nav-link text-light" to="/">
              Início
            </Link>
          </li>
          {usuario && (
            <li className="nav-item">
              <Link className="nav-link text-light" to="/perfil">
                Meu perfil
              </Link>
            </li>
          )}
          <li className="nav-item">
            {usuario ? (
              <button
                type="button"
                className="btn btn-link nav-link text-light"
                onClick={handleSair}
                aria-label="Sair da conta"
              >
                Sair
              </button>
            ) : (
              <Link className="nav-link text-light" to="/login">
                Entrar
              </Link>
            )}
          </li>
        </ul>
      </div>
    </nav>
  );
}
